import React from "react";
import wabes from './styles//images/download.svg';
import './styles/services.css';
import logo from './styles/images/mainlogo.png';
import PCA from './styles/images/PCA-img.jpg';
import CFSS from './styles/images/CFSS-img.jpg';
import Footer from "./Footer";
import Marquee from "react-fast-marquee";
import NewsTicker from "./marequee";
import TestimonialMarquee from "./testimonialmarquee";
function Service(){
    return(
        <>
         <section id="about1" className="about">
                <div className="wrap"></div>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12 col-md-12 col-sm-12 pb-5" id="about-col1">
                                <h1 className="heading">Beyond <span className="hero-highlight">Care</span>  <br /> We Create <span className="hero-highlight">Comfort</span></h1>
                                <p className="supporting">
                                Ensuring a safe, nurturing, and dignified home environment.
                                    </p>
                            </div>
                        </div>
                    </div>
                      <img src={wabes} alt="Waves" id="waves1" />
                </section>
               <section id="Our-services">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                            <h1 className="heading text-center">What we <span className="hero-highlight">Provides</span></h1>
                            <p className="  mt-3" >
                            At Sammah Home Care, we are dedicated to providing exceptional <strong> Personal Care Assistance (PCA)</strong> and <strong>Community First Services and Supports (CFSS)</strong> to ensure comfort, dignity, and independence for individuals in need. Our services are designed to support seniors, individuals with disabilities, and those recovering from illness or injury, helping them maintain their daily routines in a safe and familiar environment.

Our PCA services offer essential daily assistance, including personal hygiene, mobility support, medication reminders, meal preparation, and light housekeeping. We understand the importance of personalized care, which is why our compassionate caregivers provide one-on-one support tailored to each individual's unique needs. Whether it's assisting with dressing, transferring, or simple companionship, we are here to help.

With CFSS, we take a more person-centered approach, allowing clients to have greater control over their care. This program enables individuals to choose their caregivers, including family members, and customize their support plans. Our goal is to empower individuals by promoting independence while ensuring their health and well-being.
                            </p>
                        </div>
                    </div>
                    <div className="row mt-4">
                        <div className="col-lg-12 col-md-12 col-sm-12 text-center">
                            <img src={logo} alt="Main Logo img | Samah Home Care" width={'300px'} />
                        </div>
                    </div>
                </div>
               </section>
               <section id="Services">
               <div className="container">
                <div className="row">
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <img src={PCA} alt=" PCA" id="PCA" width={'100%'} />
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12" id="Service-col">
                        <h1>
                            Personal Care Assistant Services <span className="hero-highlight">PCA</span>
                        </h1>
                        <ul>
                            <li>Personal Hygiene</li>
                            <li>Compassionate Care</li>
                            <li>Comfort Care</li>
                            <li>Your Caregiver </li>
                        </ul>
                        <p>
                            Our PCA services are designed to support individuals with daily living tasks, ensuring they maintain their independence and
                        </p>
                        <a href="/service/PCA">Read More </a>
                    </div>
                </div>
                <div className="row mt-5">
                    <NewsTicker />
                </div>
                <div className="row mt-5">
                <div className="col-lg-6 col-md-6 col-sm-12" id="Service-col">
                        <h1>
                        Community First Services and Supports <span className="hero-highlight">CFSS</span>
                        </h1>
                        <ul>
                            <li>Personalized Care Plans</li>
                            <li>Choice of Caregiver</li>
                            <li>Enhanced Independence</li>
                            <li>Flexible Support Services</li>
                        </ul>
                        <p>
                        Our CFSS services provide personalized support, allowing individuals to take control of their care. We assist with daily living activities, health-related tasks, and personal well-being while promoting independence and choice.
                        </p>
                        <a href="/service/CFSS">Read More </a>
                    </div>
                    <div className="col-lg-6 col-md-6 col-sm-12">
                        <img src={CFSS} alt=" PCA" id="PCA" width={'100%'} />
                    </div>
                </div>
               </div>
               
               </section>
               
               <TestimonialMarquee />
               <footer>
                <Footer />
               </footer>
        </>
    )
}
export default Service;